(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calundia-panorama-footer"]) return;
  try {
    
  const stylePanoramaReviews = () => {
    const widget = document.querySelector('.pan-footer-reviews .shopauskunft-widget');
    if (!widget || !window.shopauskunftWidgetHandler) return;
    new window.shopauskunftWidgetHandler([widget]).render();
    const root = widget.shadowRoot;
    if (!root || root.querySelector('[data-panorama-reviews-style]')) return;
    const style = document.createElement('style');
    style.dataset.panoramaReviewsStyle = '';
    style.textContent = `div.sa-rating-summary-widget { --main-font-color: #fff; color: #fff; } .sa-rating-summary-widget > img { content: url("https://widget.shopauskunft.de/assets/images/shopauskunft-logo-dark.png"); }`;
    root.append(style);
  };
  document.addEventListener('DOMContentLoaded', stylePanoramaReviews, { once: true });
  if (document.readyState !== 'loading') stylePanoramaReviews();
  document.addEventListener('shopify:section:load', stylePanoramaReviews);
  document.addEventListener('click', event => {
    if (event.target.closest('.pan-cookie-preferences')) {
      window.privacyBanner?.showPreferences();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calundia-panorama"]) return;
  try {
    
  if (!customElements.get('panorama-page')) {
    customElements.define('panorama-page', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const photos = this.querySelectorAll('[data-pan-photo]');
        const thumbs = this.querySelectorAll('[data-pan-thumb]');
        const selectPhoto = (index) => {
          photos.forEach(photo => { photo.hidden = photo.dataset.panPhoto !== index; });
          thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.panThumb === index)));
        };
        this.querySelector('[data-pan-gallery-controls]').hidden = false;
        thumbs.forEach(thumb => thumb.addEventListener('click', () => selectPhoto(thumb.dataset.panThumb), options));
        const extras = this.querySelectorAll('[data-pan-extra]');
        const more = this.querySelector('[data-pan-show-motifs]');
        if (extras.length && !window.Shopify?.designMode) {
          extras.forEach(card => { card.hidden = true; });
          more.hidden = false;
          more.addEventListener('click', () => {
            extras.forEach(card => { card.hidden = false; });
            more.hidden = true;
            extras[0].focus();
          }, options);
        }
        this.querySelectorAll('.pan-subnav a').forEach(link => link.addEventListener('click', () => {
          this.querySelectorAll('.pan-subnav a').forEach(item => item.removeAttribute('aria-current'));
          link.setAttribute('aria-current', 'location');
        }, options));
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;

      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calundia-wandtrophaee"]) return;
  try {
    
  if (!customElements.get('wandtrophaee-page')) {
    customElements.define('wandtrophaee-page', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const media = this.querySelectorAll('[data-wall-media]');
        const thumbs = this.querySelectorAll('[data-wall-thumb]');
        const selectMedia = index => {
          media.forEach(item => { item.hidden = item.dataset.wallMedia !== index; });
          thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.wallThumb === index)));
        };
        this.querySelector('[data-wall-gallery-controls]').hidden = false;
        thumbs.forEach(thumb => thumb.addEventListener('click', () => selectMedia(thumb.dataset.wallThumb), options));
        this.querySelectorAll('.pan-subnav a').forEach(link => link.addEventListener('click', () => {
          this.querySelectorAll('.pan-subnav a').forEach(item => item.removeAttribute('aria-current'));
          link.setAttribute('aria-current', 'location');
        }, options));
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form-custom"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.contact-custom__form').forEach(function(form) {
      var section = form.closest('.contact-custom');
      var i18nEl = section ? section.parentElement.querySelector('script[id^="contact-form-i18n-"]') : null;
      var i18n = {};
      if (i18nEl) {
        try { i18n = JSON.parse(i18nEl.textContent); } catch(e) {}
      }

      form.addEventListener('submit', function(e) {
        var hp = form.querySelector('[name="contact[website]"]');
        if (hp && hp.value.length > 0) {
          e.preventDefault();
          return;
        }

        var btn = form.querySelector('.contact-custom__submit');
        if (btn) {
          btn.disabled = true;
          btn.textContent = btn.getAttribute('data-submitting-text') || i18n.submitting || 'Submitting...';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
